import React, { useEffect, useState } from "react";
import { SelectInput } from "@/components/toolkit/SelectInput";
import { TextInput } from "@/components/toolkit/TextInput";

export interface DToolEngineSettings {
    env?: string;
    [key: string]: unknown;
}

export function DToolSettings(props: {
    settings: DToolEngineSettings;
    onChange: (settings: DToolEngineSettings) => void;
    getMetadata: (settings: DToolEngineSettings) => Promise<any>;
}) {
    const { settings, onChange, getMetadata } = props;
    const [envOptions, setEnvOptions] = useState<{ value: string; title: string }[] | null>(null);

    useEffect(() => {
        getMetadata({}).then(meta => {
            if (Array.isArray(meta?.envs)) {
                setEnvOptions(meta.envs.map((e: string) => ({ value: e, title: e })));
            }
        }).catch(() => {});
    }, []);

    return (
        <div className="configure_deploy_env_modal__field">
            <label className="configure_deploy_env_modal__field_label">Instance (env)</label>
            {envOptions !== null && envOptions.length > 0 ? (
                <SelectInput
                    value={settings.env ?? ""}
                    options={[{ value: "", title: "— None —" }, ...envOptions]}
                    onChange={v => onChange({ ...settings, env: v ?? "" })}
                />
            ) : (
                <TextInput
                    value={settings.env ?? ""}
                    placeholder="e.g. staging"
                    onChange={v => onChange({ ...settings, env: v })}
                />
            )}
        </div>
    );
}
